import GlassCard from "../../components/GlassCard";
import { warningsContent } from "../data/warningsContent";
import { useCurrentLang } from "../../hooks/useCurrentLang";

/**
 * @typedef {|
 * "MissingPersonalInfo"
 * | "EmailNotVerified"
 * | "SubscriptionEndingSoon"
 * | "PaymentFailed"
 * | "UnfinishedSession"
 * | "UnsavedChanges"
 * | "MaintenanceBreakUpcoming"
 * | "ServiceDegraded"
 * | "PermissionMissing"
 * | "SuspiciousLoginDetected"
 * | "NoActivePlanForUser"
 * } WarningType
 */

/**
 * @param {{ warningType: WarningType, data?: Record<string, unknown> }} props
 */
export default function Warning({ warningType, data = {} }) {
    const currentLang = useCurrentLang();
    const t = warningsContent[currentLang]?.[warningType];

    if (!t) return null;

    const cardStyle = {
        padding: "10px",
        maxWidth: "775px",
        marginLeft: "50px",
        marginBottom: "25px",
        borderColor: "#ef4444",
    };

    const badgeStyle = {
        fontSize: "0.8rem",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        opacity: 0.7,
        background: "rgba(239, 68, 68, 0.6)",
        borderRadius: "99px",
        padding: "3px",
        display: "inline-block",
        marginBottom: "10px",
    };

    if (warningType === "MissingPersonalInfo") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "EmailNotVerified") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "SubscriptionEndingSoon") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "PaymentFailed") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "UnfinishedSession") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "UnsavedChanges") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "MaintenanceBreakUpcoming") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "ServiceDegraded") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "PermissionMissing") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    if (warningType === "SuspiciousLoginDetected") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }
    if (warningType === "NoActivePlanForUser") {
        return (
            <GlassCard style={cardStyle}>
                <div style={badgeStyle}>{t.label}</div>
                <h1>{t.title}</h1>
                <p>{t.description}</p>
            </GlassCard>
        );
    }

    return null;
}